import useExpense from "../hook/useExpense"
import ExpenseMainContent from "../components/ExpenseMainContent"

function ExpensePage() {
    const props = useExpense();
    return <ExpenseMainContent {...props} />
}

export default ExpensePage